<template>
  <div style="padding: 20px; height: 100%; box-sizing: border-box">
    <div class="cf" style="padding:10px">
      <div class="fl">
        操作记录
        <el-input v-model="search.platformName" placeholder="输入场站名称" size="mini" style="width: 150px; margin: 0 10px"
          @change="handleCurrentChange(1)" clearable></el-input>
        <el-input v-model="search.createTenantName" placeholder="输入企业名称" size="mini"
          style="width: 150px; margin-right: 10px;" @change="handleCurrentChange(1)" clearable></el-input>
        <el-input v-model="search.createUserName" placeholder="输入操作人" size="mini"
          style="width: 150px; margin-right: 10px;" @change="handleCurrentChange(1)" clearable></el-input>
        <el-input v-model="search.info" placeholder="输入操作记录" size="mini" style="width: 150px; margin-right: 10px;"
          @change="handleCurrentChange(1)" clearable></el-input>
      </div>
      <div class="fr">
        <el-tooltip class="item" effect="dark" content="查询" placement="top">
          <el-button size="mini" @click="init()" circle icon="el-icon-search">
          </el-button>
        </el-tooltip>
      </div>
    </div>
    <el-table :data="data" border size="mini" style="width: 100%" height="85%" v-loading="loading"
      highlight-current-row>
      <template slot="empty">
        <el-empty></el-empty>
      </template>
      <el-table-column prop="platformName" label="场站" width="200" show-overflow-tooltip align="center" />
      <el-table-column prop="createTenantName" label="企业" width="200" show-overflow-tooltip align="center" />
      <el-table-column prop="createUserName" label="操作人" width="100" show-overflow-tooltip align="center" />
      <el-table-column prop="info" label="操作记录" min-width="300" show-overflow-tooltip align="center" />
      <el-table-column prop="createTime" label="操作时间" width="180" show-overflow-tooltip align="center" />
    </el-table>
    <div style="text-align: left; padding: 10px 0">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page.current"
        :page-sizes="[20, 50, 80, 100]" :page-size="page.size" layout="total, sizes, prev, pager, next, jumper"
        :total="page.total" background>
      </el-pagination>
    </div>
  </div>
</template>

<script>
import XEUtils from 'xe-utils';


export default {
  data() {
    return {
      data: [],
      allAlign: 'center',
      loading: false,
      page: {
        total: 0,
        size: 20,
        current: 1
      },
      search: {
        platformName: '',
        createUserName: '',
        createTenantName: '',
        info: ''
      }
    }
  },
  created() {
    this.init()
  },
  mounted() {
    this.$validate.ToDocumentTitle()
  },
  methods: {
    init() {
      this.$set(this, 'loading', true)
      const params = {
        params: {
          pageNum: this.page.current,
          pageSize: this.page.size
        }
      }
      for (let key in this.search) {
        if (this.search[key])
          params.params[key] = this.search[key]
      }
      this.$axios.get('/account/operateRecord/util/queryRecord', params).then(res => {
        this.data = res.data.data.list
        this.data.forEach(item => {
          item.createTime = XEUtils.toDateString(item.createTime)
        })
        this.page.total = res.data.data.total
        this.loading = false
      }).catch(err => {
        console.log('model Err:', err)
        this.$set(this, 'loading', false)
      })
    },
    handleSizeChange(val) {
      this.page.size = val
      this.init()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.init()
    },
  }
}
</script>

<style scoped>
.cf {
  overflow: hidden
}

.fl {
  float: left;
}

.fr {
  float: right;
}
</style>
